// import { Directory } from "@capacitor/filesystem";
// import write_blob from "capacitor-blob-writer";

// ----------------------------- o

export default {
    async file(resp, fileName, typeObj) {
        // working
        let url = resp.data.url
        window.location.replace(url)

        // Blob not working(!)
        // https://github.com/ionic-team/capacitor/issues/5478
        // https://github.com/ionic-team/capacitor/pull/5498
        // https://stackoverflow.com/questions/52055126/not-allowed-to-load-local-resource-ionic-3-android

        // only for mobile devices
        // if (Capacitor.platform !== 'web') {
            // write_blob({
            //     path: "portalgastro/" + fileName,
            //     directory: Directory.Data,
            //     blob: resp.data,
            //     recursive: true,
            //     on_fallback(error) {
            //         console.error('SaveFile error', error);
            //     }
            // }).then((file_uri) => {
            //     console.log('SaveFile file_uri', file_uri)
            //     window.open(file_uri)
            // })
        // }
        // web
        // if (Capacitor.platform === 'web') {
        //     let blob = new Blob([resp.data], typeObj)
        //     const newWindow = window.open(URL.createObjectURL(blob), '_blank')
        // }
    }

}
